module.exports = __webpack_public_path__ + "img/roberto-shinyashiki.512aa407.jpg";